/* eslint-disable react/no-unused-prop-types */
import { graphql } from "gatsby";
import { isEmpty } from "lodash";
import React from "react";
import { Helmet } from "react-helmet";
import useSeo from "./useSeo";

/**
 * @typedef {{
 *  data?: Queries.SeoFragment | null;
 *  fallback?: Partial<Queries.SeoFragment> | null;
 *  page?: string | null;
 *  canonical?: string | null;
 * }} SeoProps
 *
 * @param {SeoProps} props
 */
function Seo(props) {
  const { title, description, keywords, robots, canonical } = useSeo(props);

  return (
    <Helmet>
      <link href={canonical} rel="canonical" />
      <title>{title}</title>
      {description && <meta content={description} name="description" />}
      {!isEmpty(keywords) && (
        <meta content={keywords.join(", ")} name="keywords" />
      )}
      {!isEmpty(robots) && <meta content={robots.join(", ")} name="robots" />}
    </Helmet>
  );
}

export const query = graphql`
  fragment Seo on STRAPI__COMPONENT_SEO_SEO {
    title
    description
    keywords
    index
    follow
  }
`;

export default Seo;
